let index = {
  activities: "/management/province/activities",
  coache: "/management/province/coache",
  reserve: "/management/province/reserve",
  football: "/management/province/football",
  youthTraining: "/management/province/youthTraining",
  school: "/management/province/school",
  footballIceHockey: "/management/province/footballIceHockey",
  operator: "/management/province/operator",
  updatepwd: "/management/province/updatepwd",
  tranpay_2022: "/management/province/tranpay"
};
export default [
  /**U系列赛事活动 */
  {
    path: "province/activities",
    component: () =>
      import(/* webpackChunkName: "province_activities" */ "@/views/province/management/activities/Main.vue"),
    meta: { index: index.activities },
    children: [
      {
        path: "",
        name: "province_activities_list",
        component: () =>
          import(/* webpackChunkName: "province_activities_list" */ "@/views/province/management/activities/Index.vue"),
        meta: { index: index.activities }
      },
      {
        path: ":id",
        name: "province_activities_list_editActivities",
        component: () =>
          import(
            /* webpackChunkName: "province_activities_list_editActivities" */ "@/views/province/management/activities/EditActivities.vue"
          ),
        meta: { index: index.activities }
      },
      {
        path: "new",
        name: "province_activities_list_addActivities",
        component: () =>
          import(
            /* webpackChunkName: "province_activities_list_addActivities" */ "@/views/province/management/activities/EditActivities.vue"
          ),
        meta: { index: index.activities }
      }
    ]
  },
  /**教练员培训 */
  {
    path: "province/coache",
    component: () => import(/* webpackChunkName: "province_coache" */ "@/views/province/management/coache/Main.vue"),
    meta: { index: index.coache },
    children: [
      {
        path: "",
        name: "province_coache_list",
        component: () =>
          import(/* webpackChunkName: "province_coache_list" */ "@/views/province/management/coache/Index.vue"),
        meta: { index: index.coache }
      },
      {
        path: ":id",
        name: "province_coache_list_editClass",
        component: () =>
          import(
            /* webpackChunkName: "province_coache_list_editClass" */ "@/views/province/management/coache/EditClass.vue"
          ),
        meta: { index: index.coache }
      },
      {
        path: "new",
        name: "province_coache_list_addClass",
        component: () =>
          import(
            /* webpackChunkName: "province_coache_list_addClass" */ "@/views/province/management/coache/EditClass.vue"
          ),
        meta: { index: index.coache }
      }
    ]
  },
  /**后备人才培养 */
  {
    path: "province/reserve",
    component: () => import(/* webpackChunkName: "province_reserve" */ "@/views/province/management/reserve/Main.vue"),
    meta: { index: index.reserve },
    children: [
      {
        path: "",
        name: "province_reserve_list",
        component: () =>
          import(/* webpackChunkName: "province_reserve_list" */ "@/views/province/management/reserve/Index.vue"),
        meta: { index: index.reserve }
      },
      {
        path: ":id",
        name: "province_reserve_list_editBase",
        component: () =>
          import(
            /* webpackChunkName: "province_reserve_list_editBase" */ "@/views/province/management/reserve/EditBase.vue"
          ),
        meta: { index: index.reserve }
      },
      {
        path: "new",
        name: "province_reserve_list_addBase",
        component: () =>
          import(
            /* webpackChunkName: "province_reserve_list_addBase" */ "@/views/province/management/reserve/EditBase.vue"
          ),
        meta: { index: index.reserve }
      }
    ]
  },
  /**青训中心 */
  {
    path: "province/youthTraining",
    component: () =>
      import(/* webpackChunkName: "province_youthTraining" */ "@/views/province/management/youthTraining/Main.vue"),
    meta: { index: index.youthTraining },
    children: [
      {
        path: "",
        name: "province_youthTraining_list",
        component: () =>
          import(
            /* webpackChunkName: "province_youthTraining_list" */ "@/views/province/management/youthTraining/Index.vue"
          ),
        meta: { index: index.youthTraining }
      },
      {
        path: ":id",
        name: "province_youthTraining_list_editYouth",
        component: () =>
          import(
            /* webpackChunkName: "province_youthTraining_list_editYouth" */ "@/views/province/management/youthTraining/editYouth.vue"
          ),
        meta: { index: index.youthTraining }
      },
      {
        path: "new",
        name: "province_youthTraining_list_addYouth",
        component: () =>
          import(
            /* webpackChunkName: "province_youthTraining_list_addYouth" */ "@/views/province/management/youthTraining/editYouth.vue"
          ),
        meta: { index: index.youthTraining }
      }
    ]
  },
  /**青少年足球 */
  {
    path: "province/school",
    component: () => import(/* webpackChunkName: "province_school" */ "@/views/province/management/school/Main.vue"),
    meta: { index: index.school },
    children: [
      {
        path: "",
        name: "province_school_list",
        component: () =>
          import(/* webpackChunkName: "province_school_list" */ "@/views/province/management/school/Index.vue"),
        meta: { index: index.school }
      },
      {
        path: ":id",
        name: "province_school_list_editSchool",
        component: () =>
          import(
            /* webpackChunkName: "province_school_list_editSchool" */ "@/views/province/management/school/editSchool.vue"
          ),
        meta: { index: index.school }
      },
      {
        path: "new",
        name: "province_school_list_addSchool",
        component: () =>
          import(
            /* webpackChunkName: "province_school_list_addSchool" */ "@/views/province/management/school/editSchool.vue"
          ),
        meta: { index: index.school }
      }
    ]
  },
  /**资助奥运会前8名单位 */
  {
    path: "province/supportOlympics",
    component: () =>
      import(/* webpackChunkName: "province_supportOlympics" */ "@/views/province/management/supportOlympics/Main.vue"),
    meta: { index: index.supportOlympics },
    children: [
      {
        path: "",
        name: "province_supportOlympics_list",
        component: () =>
          import(
            /* webpackChunkName: "province_supportOlympics_list" */ "@/views/province/management/supportOlympics/Index.vue"
          ),
        meta: { index: index.supportOlympics }
      },
      {
        path: ":id",
        name: "province_supportOlympics_list_editSupportOlympics",
        component: () =>
          import(
            /* webpackChunkName: "province_supportOlympics_list_editSupportOlympics" */ "@/views/province/management/supportOlympics/editSupportOlympics.vue"
          ),
        meta: { index: index.supportOlympics }
      },
      {
        path: "new",
        name: "province_supportOlympics_list_addSupportOlympics",
        component: () =>
          import(
            /* webpackChunkName: "province_supportOlympics_list_addSupportOlympics" */ "@/views/province/management/supportOlympics/editSupportOlympics.vue"
          ),
        meta: { index: index.supportOlympics }
      }
    ]
  },
  /**重点项目体校布局 */
  {
    path: "province/importantProjects",
    component: () =>
      import(
        /* webpackChunkName: "province_importantProjects" */ "@/views/province/management/importantProjects/Main.vue"
      ),
    meta: { index: index.importantProjects },
    children: [
      {
        path: "",
        name: "province_importantProjects_list",
        component: () =>
          import(
            /* webpackChunkName: "province_schoolOlympics_list" */ "@/views/province/management/importantProjects/Index.vue"
          ),
        meta: { index: index.importantProjects }
      },
      {
        path: ":id",
        name: "province_schoolOlympics_list_editImportantProjects",
        component: () =>
          import(
            /* webpackChunkName: "province_schoolOlympics_list_editImportantProjects" */ "@/views/province/management/importantProjects/editImportantProjects.vue"
          ),
        meta: { index: index.importantProjects }
      },
      {
        path: "new",
        name: "province_schoolOlympics_list_addImportantProjects",
        component: () =>
          import(
            /* webpackChunkName: "province_schoolOlympics_list_addImportantProjects" */ "@/views/province/management/importantProjects/editImportantProjects.vue"
          ),
        meta: { index: index.importantProjects }
      }
    ]
  },
  /**足球 */
  {
    path: "province/football",
    component: () =>
      import(/* webpackChunkName: "province_football" */ "@/views/province/management/football/Main.vue"),
    meta: { index: index.football },
    children: [
      {
        path: "",
        name: "province_football_list",
        component: () =>
          import(/* webpackChunkName: "province_football_list" */ "@/views/province/management/football/Index.vue"),
        meta: { index: index.football }
      },
      {
        path: ":id",
        name: "province_football_list_editFootBall",
        component: () =>
          import(
            /* webpackChunkName: "province_football_list_editFootBall" */ "@/views/province/management/football/EditFootBall.vue"
          ),
        meta: { index: index.football }
      },
      {
        path: "new",
        name: "province_football_list_addFootBall",
        component: () =>
          import(
            /* webpackChunkName: "province_football_list_addFootBall" */ "@/views/province/management/football/EditFootBall.vue"
          ),
        meta: { index: index.football }
      }
    ]
  },
  /**2022年转移支付(提前下达部分) */
  {
    path: "province/tranpay",
    component: () => import(/* webpackChunkName: "admin_tranpay" */ "@/views/province/management/tranpay/Main.vue"),
    meta: { index: index.tranpay_2022 },
    children: [
      {
        path: "",
        name: "province_tranpay_list",
        component: () =>
          import(/* webpackChunkName: "admin_tranpay_list" */ "@/views/province/management/tranpay/Index.vue"),
        meta: { index: index.tranpay_2022 }
      },
      {
        path: ":id",
        name: "province_tranpay_list_editActivities",
        component: () =>
          import(
            /* webpackChunkName: "admin_editActivities" */ "@/views/province/management/tranpay/EditActivities.vue"
          ),
        meta: { index: index.tranpay_2022 }
      },
      {
        path: "new",
        name: "province_tranpay_list_addActivities",
        component: () =>
          import(
            /* webpackChunkName: "admin_editActivities" */ "@/views/province/management/tranpay/EditActivities.vue"
          ),
        meta: { index: index.tranpay_2022 }
      }
    ]
  },
  /**操作员 */
  // {
  //   path: "province/operator",
  //   component: () =>
  //     import(/* webpackChunkName: "province_football" */ "@/views/province/management/operator/Main.vue"),
  //   meta: { index: index.operator },
  //   children: [
  //     {
  //       path: "",
  //       name: "province_operator_list",
  //       component: () =>
  //         import(/* webpackChunkName: "province_football_list" */ "@/views/province/management/operator/Index.vue"),
  //       meta: { index: index.operator }
  //     }
  //   ]
  // },
  /**修改密码 */
  {
    path: "province/updatepwd",
    component: () => import(/* webpackChunkName: "province_updatepwd" */ "@/views/setting/password/Update.vue"),
    meta: { index: index.updatepwd },
    children: [
      {
        path: "",
        name: "province_updatepwd_list",
        component: () =>
          import(/* webpackChunkName: "province_updatepwd_list" */ "@/views/setting/password/Update.vue"),
        meta: { index: index.updatepwd }
      }
    ]
  }
];
